export default {
  sections: {
    address: 'Dirección comercial',
    address_help: 'Escribe la dirección donde tu negocio está registrado. Aparece impresa en tus facturas.',
  },
  form: {
    legal_form: {
      label: 'Tipo de negocio',
      help: 'Una UG (haftungsbeschränkt) aquí equivale a una GmbH, y un e.K. a un autónomo. Para una OHG o KG, contacta con soporte.',
      options: {
        sole_trader: 'Autónomo',
        gbr: 'GbR',
        gmbh: 'GmbH / UG',
      },
    },
    legal_name: {
      label: 'Nombre de la empresa registrada',
      placeholder: 'Introduce el nombre de la empresa registrada',
      sole_trader_help: 'Déjalo vacío si operas con tu propio nombre',
    },
  },
  buttons: {
    next: 'Siguiente',
  },
};
